module.exports = { "default": require("core-js/library/fn/object/seal"), __esModule: true };